import axios from 'axios';
import { BackendURL } from '../utils/BackendURL';
const { useState, useEffect } = require('react');
const { useNavigate } = require('react-router-dom');

function Login() {

    // NAVIGATE TO SIGNUP LOGIC:
    const navigate = useNavigate();
    const navigateToSignup = () => {
        navigate('/signup')
        window.scrollTo(0, 0);
    };



    // FETCH DATA FROM MONGODB FOR CHECKING ACCOUNT EXISTENCE:
    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await axios.get(`${BackendURL}/login`);
                setData(response.data);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        };
        fetchData();
    }, []);



    // VALIDATE THE EMAIL AND PASSWORD OF USER:
    const validation = () => {
        const name = document.getElementById('lname').value;
        const password = document.getElementById('lpassword').value;
        const nameError = document.getElementById('lname-error');
        const passwordError = document.getElementById('lpassword-error');

        function checkEmailandPassword(email , password) {
            for (let i = 0; i < data.length; i++){
                if(email === data[i].userEmail){
                    if ((email === data[i].userEmail && password === data[i].userPassword)){
                        return (data[i].userName);
                    } else {
                        nameError.style.display = 'none';
                        passwordError.style.display = 'flex';
                    }
                }
            }
        }

        if (checkEmailandPassword(name , password)) {
            navigate('/');
            localStorage.setItem('UserName', JSON.stringify(checkEmailandPassword(name , password)))
            localStorage.setItem('UserEmail', JSON.stringify(name))
            window.location.reload()
        }else{
            nameError.style.display = 'flex';
            passwordError.style.display = 'flex';
        }
    };

    return (
        <main className='signup-main'>
            <div className="login_formdiv">
                <h1 className="signup_h1">LOG IN</h1>
                <form>
                    <div className="login_formdesign" id="email">
                        Email: <input type="email" name="userEmail" required id='lname' />
                        <div id="lname-error">
                            *Email is incorrect
                        </div>
                    </div>

                    <div className="login_formdesign" id="password">
                        Password: <input type="password" name="userPassword" required id='lpassword' />
                        <div id="lpassword-error">
                            *Password is incorrect
                        </div>
                    </div>

                    <input className="login_but" type="button" value="Log In" onClick={validation} />

                </form>
                <p className="text-center">
                    Don't have an account?{' '}
                    <button className="login_but" id='loginbutton' onClick={navigateToSignup}>
                        Sign Up
                    </button>
                </p>
            </div>
        </main>
    );
}

export default Login;
